import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { config as CONFIG } from "app/app.config";
import { DetalleOrdenTrabajoDTO } from "app/main/apps/shared/interfaces/detalle-orden-trabajo.interface";
import { PersonaDTO } from "app/main/apps/shared/interfaces/persona.interface";
import { CotizacionesService } from "app/main/apps/shared/services/rest/cotizaciones.service";

import { UsuarioService } from "app/main/apps/shared/services/rest/usuario.service";
import { ArchivoService } from "app/main/apps/shared/services/util/acrhivo.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { finalize } from "rxjs/operators";

@Component({
    selector: "app-ficha-orden-trabajo",
    templateUrl: "./ficha-orden-trabajo.component.html",
    styleUrls: ["./ficha-orden-trabajo.component.scss"],
})
export class FichaOrdenTrabajoComponent implements OnInit, OnChanges {
    config = CONFIG;
    @Input() detalleOOTT: DetalleOrdenTrabajoDTO;
    @Output() verContratista: EventEmitter<number> = new EventEmitter();
    @Output()
    recibirRechazarOOTT: EventEmitter<DetalleOrdenTrabajoDTO> = new EventEmitter();
    @Output()
    evaluarTrabajo: EventEmitter<DetalleOrdenTrabajoDTO> = new EventEmitter();
    @Output() verAvanceTrabajo: EventEmitter<{
        idTrabajo: number;
        idOOTT: number;
    }> = new EventEmitter();
    @Output() anularOOTTEvent: EventEmitter<{
        idOOTT: number;
        nombreCliente: string;
        nombreSucursal: string;
    }> = new EventEmitter();

    @Output() anularTrabajoEvent: EventEmitter<{
        idOOTT: number;
        idTrabajo: number;
    }> = new EventEmitter();

    @Output() abrirListadoContratistas: EventEmitter<{
        idOOTT: number;
        puedeAsignar: boolean;
    }> = new EventEmitter();

    @Output() informaPago: EventEmitter<number> = new EventEmitter();
    @Output() verInvitacionesEvent: EventEmitter<number> = new EventEmitter();

    @Output() corregirObservaciones: EventEmitter<number> = new EventEmitter();

    @Output()
    verPersonalApoyoEvent: EventEmitter<PersonaDTO> = new EventEmitter();

    @Output()
    descargarOOTTEvent: EventEmitter<number> = new EventEmitter();

    fotoContratista: SafeUrl;
    constructor(
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _usuarioSrvc: UsuarioService,
        private sanitizer: DomSanitizer,
        private _archivoSrvc: ArchivoService,
        private _cotizacionSrvc: CotizacionesService,
        private _fuseProgressBarService: FuseProgressBarService //private _oottSrvc: OrdenesDeTrabajoService
    ) {}

    ngOnInit(): void {
        if (this.detalleOOTT.trabajo) {
            this.buscarFotoPerfil();
        }
        //this._oottSrvc.refreshOOTT$.subscribe(resp=>{
        //    this.buscarFotoPerfil();
        //});
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes.detalleOOTT.currentValue !=
                changes.detalleOOTT.previousValue &&
            this.detalleOOTT.trabajo
        ) {
            this.buscarFotoPerfil();
        }
    }

    buscarFotoPerfil() {
        this._usuarioSrvc
            .fetchFoto(this.detalleOOTT.trabajo.contratista.codigoFoto)
            .subscribe((blob) => {
                let url = window.URL.createObjectURL(blob);
                //console.log(url);
                this.fotoContratista =
                    this.sanitizer.bypassSecurityTrustUrl(url);
            });
    }

    abrirFichaContratista(idContratista: number) {
        this.verContratista.emit(idContratista);
    }

    verAvance(idTrabajo: number) {
        //console.log(idTrabajo);
        const data = {
            idTrabajo,
            idOOTT: this.detalleOOTT.idOrdenTrabajo,
        };
        this.verAvanceTrabajo.emit(data);
    }

    recibir() {
        this.recibirRechazarOOTT.emit(this.detalleOOTT);
    }
    evaluar() {
        //console.log(this.detalleOOTT);
        this.evaluarTrabajo.emit(this.detalleOOTT);
    }

    corregir() {
        this.corregirObservaciones.emit(this.detalleOOTT.idOrdenTrabajo);
    }

    anularOOTT() {
        const data = {
            nombreCliente: this.detalleOOTT.servicio.sucursal.cliente.nombre,
            idOOTT: this.detalleOOTT.idOrdenTrabajo,
            nombreSucursal: this.detalleOOTT.servicio.sucursal.nombre,
        };
        this.anularOOTTEvent.emit(data);
    }

    anularTrabajo() {
        const data = {
            idTrabajo: this.detalleOOTT.trabajo.id,
            idOOTT: this.detalleOOTT.idOrdenTrabajo,
        };
        this.anularTrabajoEvent.emit(data);
    }

    asignarContratista() {
        //console.log("llego");
        const data = {
            idOOTT: this.detalleOOTT.idOrdenTrabajo,
            puedeAsignar: !this.detalleOOTT.trabajo,
        };
        this.abrirListadoContratistas.emit(data);
    }

    informarPago(idTrabajo: number) {
        //console.log(idTrabajo);
        this.informaPago.emit(idTrabajo);
    }

    descargar() {
        this._fuseProgressBarService.show();
        this._cotizacionSrvc
            .fetchArchivoCotizacion(
                this.detalleOOTT.servicio.idServicioSolicitudCotizacion
            )
            .pipe(finalize(() => this._fuseProgressBarService.hide()))
            .subscribe((blob) =>
                this._archivoSrvc.descargar(
                    blob,
                    `documento_${this.detalleOOTT.idOrdenTrabajo}`
                )
            );
    }

    descargarOOTT() {
        this.descargarOOTTEvent.emit(this.detalleOOTT.idOrdenTrabajo);
    }

    verPersonalApoyo(personalApoyo: PersonaDTO) {
        this.verPersonalApoyoEvent.emit(personalApoyo);
    }

    verInvitaciones() {
        this.verInvitacionesEvent.emit(this.detalleOOTT.idOrdenTrabajo);
    }
}
